import { render, staticRenderFns } from "./FeatureItem.vue?vue&type=template&id=1e31a39d&scoped=true&"
import script from "./FeatureItem.vue?vue&type=script&lang=js&"
export * from "./FeatureItem.vue?vue&type=script&lang=js&"
import style0 from "./FeatureItem.vue?vue&type=style&index=0&id=1e31a39d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e31a39d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemAvatar,VListItemContent,VListItemTitle})
